import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {useSettingsStore} from "@/api/store/settings";
import {useUserStore} from "@/api/store/user";
import {inject, onMounted, reactive} from "vue";
import GpDetails from "@/views/ClientComponents/MedicalDetails/GpDetails.vue";
import InsuranceDetails from "@/views/ClientComponents/MedicalDetails/InsuranceDetails.vue";
import {clientService} from "@/api/services/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'MedicalDetails',
  setup(__props) {

const settingsStore = useSettingsStore();
const userStore = useUserStore();

const snackBarPlugin = inject('snackbar');

const state = reactive({
  data: null,
  gpDetails: {
    edit: false,
  },
  insuranceDetails: {
    edit: false,
  },
})

let stateBackup = JSON.parse(JSON.stringify(state.data))

const onEdit = (key) => {
  stateBackup = JSON.parse(JSON.stringify(state.data))
  state[key].edit = true
}

const onClose = (key) => {
  state.data = JSON.parse(JSON.stringify(stateBackup))
  state[key].edit = false
}

const saveGpDetails = (data) => {
  state.gpDetails.edit = false;
  userStore.updateGpDetails(data).then(() => {
    snackBarPlugin.successSnackbar('GP details updated successfully');
  }).catch(() => {
    snackBarPlugin.errorSnackbar('Failed to update GP details');
  })
}

const saveInsuranceDetails = (data) => {
  state.insuranceDetails.edit = false;
  userStore.updateInsuranceDetails(data).then(() => {
    snackBarPlugin.successSnackbar('Insurance details updated successfully');
  }).catch(() => {
    snackBarPlugin.errorSnackbar('Failed to update insurance details');
  })
}

const fetchData = () => {
  
  clientService.profileDetails().then(({data}) => {
    state.data = data;
    
  })
}

onMounted(() => {
  fetchData();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!state.insuranceDetails.edit)
      ? (_openBlock(), _createBlock(GpDetails, {
          key: 0,
          "button-color": _unref(settingsStore).settings.buttonColor,
          color: _unref(settingsStore).settings.primaryColor,
          data: state.data?.gp_details,
          edit: state.gpDetails.edit,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (onClose('gpDetails'))),
          onEdit: _cache[1] || (_cache[1] = ($event: any) => (onEdit('gpDetails'))),
          onSave: saveGpDetails
        }, null, 8, ["button-color", "color", "data", "edit"]))
      : _createCommentVNode("", true),
    (!state.gpDetails.edit)
      ? (_openBlock(), _createBlock(InsuranceDetails, {
          key: 1,
          "button-color": _unref(settingsStore).settings.buttonColor,
          color: _unref(settingsStore).settings.primaryColor,
          data: state.data?.insurance_details,
          edit: state.insuranceDetails.edit,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (onClose('insuranceDetails'))),
          onEdit: _cache[3] || (_cache[3] = ($event: any) => (onEdit('insuranceDetails'))),
          onSave: saveInsuranceDetails
        }, null, 8, ["button-color", "color", "data", "edit"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})